import { useNavigate } from 'react-router-dom';
import Layout from '../shared/Layout';
import PageHeader from '../shared/PageHeader';
import FilterBar from '../../components/settings/FilterBar';
import Icon from '../../components/tables/Icon';
import IconAdd from '../../components/icons/IconAdd';
import useExerciseTemplateList from './useExerciseTemplateList';
import ExerciseTemplateCreateModal from './ExerciseTemplateCreateModal';
import language from '../../variables/language';
import '../../css/exercise-templates.css';

const url = '/api/exercisetemplates';

const ExerciseTemplates = () => {
   const navigate = useNavigate();
   const lang = language[language.lang];
   const {
      templates, levels, classifications, search, setSearch, levelFilter, setLevelFilter,
      classificationFilter, setClassificationFilter,
      createOpen, openCreate, closeCreate, onCreated, refreshList,
   } = useExerciseTemplateList();

   return (
      <Layout>
         <PageHeader name='Шаблони вправ'>
            <FilterBar
               search={{ value: search, onChange: setSearch, placeholder: lang.placeholderSearch }}
               filters={[{
                  key: 'level', type: 'select', label: lang.level,
                  options: levels, value: levelFilter, onChange: setLevelFilter,
               }, {
                  key: 'classification', type: 'select', label: lang.clasification,
                  options: classifications, value: classificationFilter, onChange: setClassificationFilter,
               }]}
               resultCount={templates.length} />
            <div className='exercise-templates-header-actions'>
               <div className='exercise-templates-add-btn' onClick={openCreate} title='Створити шаблон'>
                  <IconAdd />
               </div>
            </div>
         </PageHeader>
         <main className='main-block'>
            <div className='main-content txt-c exercise-templates-page'>
               <table className='table exercise-templates-table'>
                  <thead>
                     <tr>
                        <th>{lang.name}</th>
                        <th>{lang.level}</th>
                        <th>{lang.clasification}</th>
                        <th>{lang.type}</th>
                        <th></th>
                     </tr>
                  </thead>
                  <tbody>
                     {templates.map(template => (
                        <tr key={template.id} className='exercise-templates-row' onClick={() => navigate('/exercise-templates/' + template.id)}>
                           <td>
                              <div className='exercise-templates-name-cell'>
                                 <span className='exercise-templates-name-text'>{template.name}</span>
                                 {template.description ? <span className='exercise-templates-desc-text'>{template.description}</span> : ''}
                              </div>
                           </td>
                           <td>{template.level ? <span className='exercise-templates-badge'>{template.level.name}</span> : ''}</td>
                           <td>{template.classification ? <span className='exercise-templates-badge'>{template.classification.name}</span> : ''}</td>
                           <td>{template.type ? <span className='exercise-templates-badge'>{template.type.name}</span> : ''}</td>
                           <td className='exercise-templates-actions-cell' onClick={e => e.stopPropagation()}>
                              <Icon mode='delete' url={url + '/' + template.id} onRefreshHundler={refreshList} className='icon-delete' classes='icon-dimensions-big' />
                           </td>
                        </tr>
                     ))}
                     {templates.length === 0 ? (
                        <tr className='exercise-templates-empty-row'><td colSpan={5}>{lang['Empty list']}</td></tr>
                     ) : ''}
                  </tbody>
               </table>
            </div>
         </main>
         <ExerciseTemplateCreateModal isOpen={createOpen} onClose={closeCreate} onCreated={onCreated} />
      </Layout>
   );
}

export default ExerciseTemplates;
